/* ============================================================================
   ARN Tiered Bundle Builder  —  asset: arn-tiered-bundle-builder.js
   Reads per-section config + products from the JSON block printed by
   sections/arn-tiered-bundle-builder.liquid, then drives the UI.

   PURCHASE PATHS:
     - ONE-TIME: adds the chosen boxes as real component variants at full price,
       tagged _arn_bundle so the Shopify Function applies the count tier
       (10/15/20% at 3/4/5).
     - SUBSCRIBE: adds the same component lines as plain subscription lines, each
       carrying the Loop selling plan that matches the box count. That plan has
       the tier AND the sub discount already baked in (3 box 19%, 4 box 24%,
       5 box 28%), so the full discount recurs on every renewal, not just the
       first order. No Loop bundle, no _bundleId, so the cart and drawer render
       these as normal subscription lines. The contract is owned and billed by
       Loop because the plan ids belong to Loop.

   FAIL SAFE: if the plan id for the chosen box count is not set, subscribe
   refuses to proceed and asks the customer to choose one-time. There is no path
   that creates a wrong-tier or unbilled subscription.
   ============================================================================ */
(function(){
  function initBuilder(root){
    if(!root || root.dataset.arnBbReady === '1') return;
    var cfgEl = root.querySelector('script[type="application/json"][data-arn-bb-config]');
    if(!cfgEl) return;
    var CONFIG;
    try { CONFIG = JSON.parse(cfgEl.textContent); } catch(e){ return; }
    root.dataset.arnBbReady = '1';

    var PRODUCTS = CONFIG.products || [];
    var PLANS = CONFIG.loopPlans || {};
    // Loop selling plan ids by box count AND delivery frequency (weeks). The
    // 4-week id per count still comes from section settings (CONFIG.loopPlans)
    // so the editor stays the source of truth for it; the 2/6/8-week ids are the
    // verified Loop plan ids for each tier group. 5-box has no 2-week plan in
    // Loop, so it is intentionally absent and the dropdown hides that option.
    var FREQ_PLANS = {
      3: { 2:'714787357055', 4:'714783162751', 6:'714787389823', 8:'714787422591' },
      4: { 2:'714787258751', 4:'714783326591', 6:'714787291519', 8:'714787324287' },
      5: {                   4:'714783392127', 6:'714787193215', 8:'714787225983' }
    };
    var freqWeeks = 4; // default delivery cadence, matches the previous behaviour
    var slots = [], slotCount = 5, mode = 'sub', tab = 'all', busy = false;
    var q = function(s){ return root.querySelector(s); };
    var by = function(i){ return PRODUCTS.find(function(p){ return p.variant === i; }); };
    // Market-aware money formatting. On the storefront Shopify exposes the
    // shopper's active presentment currency (e.g. GBP for the UK market) on
    // window.Shopify.currency.active, and under Shopify Markets the prices Liquid
    // hands this section are already in that currency. So we read the active
    // currency code and format with Intl, instead of bolting a euro sign on
    // everything. Falls back to EUR if the global isn't present.
    var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var MONEY = null;
    try { MONEY = new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }); } catch(e){ MONEY = null; }
    var fmt = function(n){
      var v = (typeof n === 'number' && isFinite(n)) ? n : 0;
      return MONEY ? MONEY.format(v) : (CURRENCY + ' ' + v.toFixed(2));
    };
    function tier(n){ if(n>=5) return CONFIG.t5; if(n===4) return CONFIG.t4; if(n>=CONFIG.minBoxes) return CONFIG.t3; return 0; }

    // Loop plan id for a given box count, or null if not configured.
    function planForCount(n){
      var v = PLANS[n] || PLANS[String(n)];
      if(!v) return null;
      v = ('' + v).trim();
      return /^\d+$/.test(v) ? v : null;
    }

    // Loop plan id for a box count AND delivery frequency (weeks). For 4 weeks we
    // prefer the section-settings value (kept as the editor source of truth),
    // then fall back to the built-in matrix. Other cadences use the matrix.
    function planFor(count, weeks){
      if(weeks === 4){ var s = planForCount(count); if(s) return s; }
      var per = FREQ_PLANS[count] || FREQ_PLANS[String(count)];
      if(!per) return null;
      var id = per[weeks] || per[String(weeks)];
      return id ? ('' + id) : null;
    }
    // Every-2-weeks exists for 3 and 4 box, but not 5 box, in Loop.
    function twoWeekAllowed(count){ return count !== 5; }

    // Subscribe discount for a box count, matching the Loop plan that gets
    // charged (3 box 19, 4 box 24, 5 box 28). This drives the SHOWN subscribe
    // price, so what the customer sees equals what Loop bills. Falls back to the
    // old tier-times-sub stack only if a per-count value is missing.
    function subPctForCount(n){
      var m = CONFIG.subPct || {};
      var v = m[n]; if(v == null) v = m[String(n)];
      return (typeof v === 'number' && v > 0) ? v : null;
    }

    function tot(){
      var s=0,b=0,pr=0,f=0;
      slots.forEach(function(id){ var x=by(id); s+=x.price; b+=x.bars; pr+=x.bars*x.prot; f+=x.bars*x.fib; });
      var n=slots.length, d=tier(n), at=s*(1-d);
      var sp=subPctForCount(n), sub=(sp!=null) ? s*(1-sp) : at*(1-CONFIG.subDiscount);
      return {n:n,s:s,d:d,once:at,sub:sub,b:b,p:pr,f:f};
    }

    // Small line-style box-stack glyph repeated once per box in the tier, so the
    // card shows 3, 4 or 5 little boxes above the label. Decorative only
    // (aria-hidden); the count is already in the label and aria-pressed.
    function boxStack(n){
      var box = '<svg class="bx" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" stroke-linecap="round"><rect x="3.5" y="7" width="17" height="12.5" rx="1.5"/><path d="M3.5 11h17"/><path d="M12 7v4"/></svg>';
      var out = ''; for(var i=0;i<n;i++){ out += box; }
      return '<span class="boxstack" aria-hidden="true">'+out+'</span>';
    }
    q('[data-sizes]').innerHTML = CONFIG.sizes.map(function(s){
      return '<button type="button" class="size'+(s.n===slotCount?' on':'')+'" data-n="'+s.n+'" aria-pressed="'+(s.n===slotCount)+'"><span class="spill spill--'+s.w+'">Save '+s.pct+'%</span>'+boxStack(s.n)+'<div class="n">'+s.label+'</div><div class="d">'+s.sub+'</div></button>';
    }).join('');
    q('[data-sizes]').onclick = function(e){ var c=e.target.closest('.size'); if(!c) return; slotCount=+c.dataset.n; if(slots.length>slotCount) slots=slots.slice(0,slotCount); render(); };

    q('[data-tabs]').innerHTML = CONFIG.tabs.map(function(t){ return '<button type="button" class="tab'+(t.k===tab?' on':'')+'" data-tab="'+t.k+'" aria-pressed="'+(t.k===tab)+'">'+t.label+(t.sub?'<small>'+t.sub+'</small>':'')+'</button>'; }).join('');
    q('[data-tabs]').onclick = function(e){ var b=e.target.closest('.tab'); if(!b) return; tab=b.dataset.tab; render(); };

    function renderSlots(){
      var row=q('[data-slots]'); row.innerHTML='';
      for(var i=0;i<slotCount;i++){
        var freeSlot=(slotCount===5 && i===4), div=document.createElement('div');
        if(i<slots.length){ var p=by(slots[i]);
          div.className='slot filled'+(freeSlot?' free':''); if(p.image) div.style.backgroundImage='url('+p.image+')';
          div.innerHTML=(freeSlot?'<span class="freetag" aria-hidden="true">🎁</span>':'')+'<button type="button" class="x" data-i="'+i+'" aria-label="Remove '+p.flavour+'">×</button>';
        } else { var isNext=(i===slots.length);
          div.className='slot empty'+(freeSlot?' free':isNext?' next':'');
          div.innerHTML='<span class="pl" aria-hidden="true">'+(freeSlot?'🎁':'+')+'</span><span class="cap">'+(freeSlot?'Free box':(isNext?'Add':'&nbsp;'))+'</span>';
        }
        row.appendChild(div);
      }
      row.querySelectorAll('[data-i]').forEach(function(b){ b.onclick=function(){ slots.splice(+b.dataset.i,1); render(); }; });
    }
    var FULL_PALETTE='#d2be9d,#b7cd8e,#c79ec8,#a2c9b4,#80bbd9,#fd9e54,#ede351,#e69cb0,#e57169';
    function heroBand(p){
      var raw=(p.band&&(''+p.band).trim())?(''+p.band):FULL_PALETTE;
      var cols=raw.split(',').map(function(c){return c.trim();}).filter(Boolean);
      if(cols.length===1) return cols[0];
      var step=100/cols.length, stops=[];
      for(var i=0;i<cols.length;i++){ stops.push(cols[i]+' '+(i*step).toFixed(3)+'% '+((i+1)*step).toFixed(3)+'%'); }
      return 'linear-gradient(90deg,'+stops.join(',')+')';
    }
    function renderGrid(){
      var full=slots.length>=slotCount;
      var list = PRODUCTS.filter(function(p){ return tab==='all' || p.type===tab; });
      q('[data-grid]').innerHTML = list.map(function(p){
        var n=slots.filter(function(id){ return id===p.variant; }).length;
        var sold = !p.avail;
        var control = sold
          ? '<button type="button" class="add" disabled aria-label="'+p.flavour+' is sold out">Sold out</button>'
          : (n>0
            ? '<div class="stepper"><button type="button" data-m="'+p.variant+'" aria-label="Remove one '+p.flavour+'">−</button><span>'+n+'</span><button type="button" data-p="'+p.variant+'" '+(full?'disabled':'')+' aria-label="Add one '+p.flavour+'">+</button></div>'
            : '<button type="button" class="add" data-p="'+p.variant+'" '+(full?'disabled':'')+' aria-label="Add '+p.flavour+' to your box">'+(full?'Box full':'+ Add')+'</button>');
        var soldtag = sold ? '<span class="soldtag">Sold out</span>' : '';
        var pc = 'prod'+(sold?' is-sold-out':'');
        var best = p.best ? '<span class="best">Bestseller</span>' : '';
        var nm = '<div class="nm">'+p.flavour+'</div>';
        var note = p.note ? '<div class="cardnote">'+p.note+'</div>' : '';
        var meta = '<div class="meta">'+p.bars+' bars · '+p.size+' · '+fmt(p.price)+'</div>';
        if(p.type==='mixed' && p.hero){
          var art = p.image ? '<img class="hero-img" src="'+p.image+'" alt="'+p.flavour+'" loading="lazy">' : '';
          return '<div class="'+pc+' prod--hero" role="listitem">'
            + '<div class="hero-art" style="background:'+heroBand(p)+'">'+art+soldtag+'</div>'
            + '<div class="hero-body">'+best+nm+note+meta+control+'</div>'
            + '</div>';
        }
        if(p.type==='mixed'){
          var mimg = p.image ? '<img class="bar-img" src="'+p.image+'" alt="'+p.flavour+'" loading="lazy">' : '';
          return '<div class="'+pc+'" role="listitem"><div class="thumb" style="background:'+heroBand(p)+'">'+mimg+soldtag+'</div>'+best+nm+meta+control+'</div>';
        }
        var minitag = p.type==='mini' ? '<span class="minitag">Mini</span>' : '';
        var thumb;
        if(CONFIG.contain && p.image){
          thumb = '<div class="thumb" style="background:'+p.flavourColor+'"><img class="bar-img" src="'+p.image+'" alt="'+p.flavour+'" loading="lazy">'+minitag+soldtag+'</div>';
        } else {
          var base = p.image ? 'background-image:url('+p.image+')' : 'background:'+p.color;
          thumb = '<div class="thumb" style="'+base+'">'+(p.image?'':p.flavour)+minitag+soldtag+'</div>';
        }
        return '<div class="'+pc+'" role="listitem">'+thumb+best+nm+meta+control+'</div>';
      }).join('');
      q('[data-grid]').querySelectorAll('[data-p]').forEach(function(b){ b.onclick=function(){ if(slots.length<slotCount){ slots.push(+b.dataset.p); render(); } }; });
      q('[data-grid]').querySelectorAll('[data-m]').forEach(function(b){ b.onclick=function(){ var i=slots.lastIndexOf(+b.dataset.m); if(i>-1){ slots.splice(i,1); render(); } }; });
      root.querySelectorAll('.tab').forEach(function(t){ var on=t.dataset.tab===tab; t.classList.toggle('on', on); t.setAttribute('aria-pressed', on); });
    }
    function render(){
      root.querySelectorAll('.size').forEach(function(el){ var on=+el.dataset.n===slotCount; el.classList.toggle('on', on); el.setAttribute('aria-pressed', on); });
      renderSlots(); renderGrid();
      var t=tot(), n=t.n, price = mode==='sub'?t.sub:t.once;
      updateFreqPick(slotCount);
      q('[data-count]').textContent = n+' of '+slotCount+(slotCount===1?' box':' boxes');
      q('[data-rrp]').textContent = price<t.s-0.005?fmt(t.s):'';
      q('[data-total]').textContent = fmt(price);
      var sv=t.s-price, pct=t.s>0?Math.round(sv/t.s*100):0;
      q('[data-save]').innerHTML = sv>0.005?'You save <b>'+fmt(sv)+'</b> · '+pct+'% off vs buying individually':'';
      q('[data-fbwrap]').innerHTML = n>0?'<span class="freebox">'+fmt(price/t.b)+' per bar</span>':'';
      q('[data-lp-once]').textContent=fmt(t.once); q('[data-lp-sub]').textContent=fmt(t.sub);
      var cta=q('[data-cta]'), rem=slotCount-n, label;
      if(busy) label='Adding…';
      else if(n===0) label='Add boxes to start';
      else if(n<CONFIG.minBoxes) label='Add '+(CONFIG.minBoxes-n)+' more to unlock '+Math.round(CONFIG.t3*100)+'%';
      else if(rem>0) label=(slotCount===5&&rem===1)?'Add your free box →':'Fill '+rem+' more slot'+(rem>1?'s':'');
      else label='Add '+n+' '+(n===1?'box':'boxes')+' · '+fmt(price);
      cta.textContent=label; cta.disabled = busy || n<CONFIG.minBoxes;
      q('[data-live]').textContent = n===0?'Your box is empty.':(n+' '+(n===1?'box':'boxes')+' in your box. Total '+fmt(price)+'.'+(sv>0.005?' You save '+fmt(sv)+'.':''));
    }

    function selectFreq(l){ if(!l) return; mode=l.dataset.mode; root.querySelectorAll('.freq-row').forEach(function(x){ x.classList.toggle('on', x===l); }); var inp=l.querySelector('input'); if(inp) inp.checked=true; render(); }
    q('[data-freq]').onclick = function(e){ var l=e.target.closest('.freq-row'); selectFreq(l); };
    root.querySelectorAll('.freq input[type=radio]').forEach(function(inp){ inp.addEventListener('change', function(){ selectFreq(inp.closest('.freq-row')); }); });

    // Delivery-frequency step for Subscribe, built as selectable pills so it
    // matches the box-size and flavour steps. Injected here (the section markup
    // is a separate, older file) and placed as its own block directly above the
    // subscribe / one-time toggle, never wedged between those two options.
    var freqPick = (function(){
      var host = q('[data-freq]'); if(!host || !host.parentNode) return null;
      var step = document.createElement('div');
      step.className = 'arn-bb-freqstep';
      step.setAttribute('data-freqstep','');
      var weeks = [2,4,6,8];
      step.innerHTML = '<span class="arn-bb-freqstep__label">Deliver every</span>'
        + '<div class="arn-bb-freqpills" role="group" aria-label="Delivery frequency">'
        + weeks.map(function(w){
            var on = (w === freqWeeks);
            return '<button type="button" class="arn-bb-freqpill'+(on?' on':'')+'" data-w="'+w+'" aria-pressed="'+on+'">'+w+' weeks</button>';
          }).join('')
        + '</div>';
      host.parentNode.insertBefore(step, host);
      var pills = step.querySelectorAll('.arn-bb-freqpill');
      step.addEventListener('click', function(e){
        var b = e.target.closest('.arn-bb-freqpill'); if(!b || b.disabled) return;
        freqWeeks = +b.dataset.w || 4; render();
      });
      return { step: step, pills: pills };
    })();

    function updateFreqPick(count){
      if(!freqPick) return;
      var allow2 = twoWeekAllowed(count);
      if(!allow2 && freqWeeks === 2){ freqWeeks = 4; }
      freqPick.pills.forEach(function(b){
        var w = +b.dataset.w, hide = (w === 2 && !allow2), on = (w === freqWeeks && !hide);
        b.hidden = hide;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on);
      });
    }

    function setPanel(open){
      var panel=q('[data-panel]'); panel.classList.toggle('open', open);
      var btn=q('[data-toggle]'); if(btn) btn.setAttribute('aria-expanded', open);
      var lbl=q('[data-toggle-label]'); if(lbl) lbl.textContent = open?'Hide box':'View box';
    }
    q('[data-bar]').onclick = function(){
      if(window.matchMedia('(min-width:900px)').matches) return;
      setPanel(!q('[data-panel]').classList.contains('open'));
    };

    // Collapse the chosen slots to one cart item per variant, with quantity.
    function bundleLines(props, plan){
      var counts={};
      slots.forEach(function(id){ counts[id]=(counts[id]||0)+1; });
      return Object.keys(counts).map(function(id){
        var item={ id:+id, quantity:counts[id] };
        if(plan){ item.selling_plan = +plan; }
        if(props && Object.keys(props).length){ item.properties = props; }
        return item;
      });
    }

    function addToCart(items){
      return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: items }) })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); });
    }

    // Hand back to the theme's own cart flow. Archetype rebuilds the drawer from
    // /cart.js and slides it open when 'added.ajaxProduct' fires on the body,
    // the same event its native add-to-cart buttons use. So we trigger that
    // instead of loading the full /cart page. If jQuery is missing for any
    // reason, fall back to /cart so an add is never lost.
    function revealCart(){
      var jq = window.jQuery || window.$;
      if(jq && jq.fn){ jq('body').trigger('added.ajaxProduct'); return; }
      window.location = '/cart';
    }

    q('[data-cta]').onclick = function(){
      if(busy || slots.length < CONFIG.minBoxes) return;

      // SUBSCRIBE: attach the Loop plan that matches the box count. The tier and
      // sub discount are baked into that plan, so the full discount recurs.
      if(mode === 'sub'){
        var count = slots.length;
        var plan = planFor(count, freqWeeks) || planFor(count, 4);
        if(!plan){
          alert('Subscriptions aren\u2019t set up for a ' + count + '-box just yet. Please choose one-time for now.');
          return;
        }
        busy = true; render();
        addToCart(bundleLines(null, plan))
          .then(function(){ busy=false; render(); revealCart(); })
          .catch(function(){ busy=false; render(); alert('Something went wrong adding your subscription. Please try again.'); });
        return;
      }

      // ONE-TIME: real component variants at full price, tagged for the Function.
      busy = true; render();
      var bundleId = 'arn-' + Date.now() + '-' + Math.random().toString(36).slice(2,8);
      addToCart(bundleLines({ _arn_bundle: '1', _arn_bundle_id: bundleId }, null))
        .then(function(){ busy=false; render(); revealCart(); })
        .catch(function(){ busy=false; render(); alert('Something went wrong adding your box. Please try again.'); });
    };

    render();
  }

  function initAll(ctx){ (ctx||document).querySelectorAll('[data-arn-bb]').forEach(initBuilder); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  // Theme editor: re-init when the section is added or reloaded.
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('[data-arn-bb]');
    if(r){ r.dataset.arnBbReady = ''; initBuilder(r); }
  });
})();